module.exports = __webpack_public_path__ + "static/media/right-arrow-soul.b511ff9b.svg";